import React, { useState } from 'react';
import Sidebar from '../components/Layout.tsx';
import Wallet from './Wallet';
import Wishlist from './WishList';
import Deposits from './Deposits';
import Rewards from './Rewards';
import Referrals from './Referrals';
import Withdrawals from './Withdrawals';
import PaymentAccounts from './PaymentAccount';
import WithdrawalRequest from './WithdrawalRequest';
import DepositFunds from './DepositFunds';
import TransferRewards from './TransferRewards';
import '../../index.css'
import Profile from './Profile';
import Purchases from './Purchases';
import SupportTickets from './SupportTickets';
import UserFeedBack from './UserFeedBack';
import AvailableServices from "./AvailableServices.tsx";
import TemplateSuggestions from "./TemplateSuggestions.tsx";
import ContactForm from './ContactFormSubmission.tsx'
import TemplatesDashboardAnalytics from "./TemplatesDashboardAnalytics.tsx";
import CreateAd from './Ads/CreateAd.tsx'
import Adlist from './Ads/Adlist.tsx'
import DashboardAds from './Ads/DashboardAds.tsx'
import DigitalAssetsTable from './Digitals/DigitalAssets.tsx';
import TemplatesTable from './Digitals/TemplateTable.tsx';

const componentMap: { [key: string]: React.ReactNode } = {
  wallet: <Wallet />,
  wishlist: <Wishlist />,
  deposits: <Deposits />,
  depositFunds: <DepositFunds />,
  rewards: <Rewards />,
  transferRewards: <TransferRewards />,
  referrals: <Referrals />,
  withdrawals: <Withdrawals />,
  withdrawalRequest: <WithdrawalRequest />,
  paymentAccounts: <PaymentAccounts />,
  profile: <Profile />,
  purchases: <Purchases />,
  supportTickets: <SupportTickets />,
  userFeedBack: <UserFeedBack />,
  availableServices: <AvailableServices />,
  templateSuggestions: <TemplateSuggestions />,
  contactForm: <ContactForm />,
  templatesDashboardAnalytics: <TemplatesDashboardAnalytics />,
  createAd: <CreateAd />,
  adlist: <Adlist />,
  dashboardAds: <DashboardAds />,
   digitals: <DigitalAssetsTable />,
   templates: <TemplatesTable />


};

export const DashboardWallet: React.FC = () => {
    const [activeComponent, setActiveComponent] = useState<React.ReactNode>(<Wallet />);

    const handleNavigation = (componentKey: string) => {
        setActiveComponent(componentMap[componentKey] || <Wallet />);
    };

    return (
        <div className="flex h-screen scrollbar-hidden bg-gray-50">
            <Sidebar onNavigate={handleNavigation} />
            <main className="flex-1 overflow-auto p-6">{activeComponent}</main>
        </div>
    );
};
